import { useEffect } from "react";
import { pushToDataLayer } from "../../utils/analytics";
import github from "../../assets/icons/github_icon.png";
import "./ProjectModal.scss";

function ProjectModal({ project, onClose }) {
  const titleId = `project-${project.id}-title`;
  const descId = `project-${project.id}-description`;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  if (!project) return null;
  const handleProjectLinkClick = (linkType, linkUrl) => {
    pushToDataLayer("project_link_click", {
      project_id: project.id,
      project_name: project.name,
      link_type: linkType,
      link_url: linkUrl,
    });
  };
  return (
    <div className="project-modal-overlay" onClick={onClose} aria-hidden="true">
      <div
        className="project-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descId}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="project-modal__close"
          onClick={onClose}
          aria-label={`Close ${project.name} project details`}
        >
          <span aria-hidden="true">×</span>
        </button>

        <h3 id={titleId} className="project-modal__title">
          {project.name}
        </h3>

        <div className="project-modal__media">
          {project.modalVideo ? (
            <video
              className="project-modal__image"
              src={project.modalVideo}
              autoPlay
              muted
              loop
              playsInline
              width={project.modalWidth || 1200}
              height={project.modalHeight || 675}
              aria-label={project.modalImageAlt || ""}
            />
          ) : (
            <img
              className="project-modal__image"
              src={project.modalImage || project.image}
              alt={project.modalImageAlt || project.imageAlt || ""}
              width={project.modalWidth || 1200}
              height={project.modalHeight || 675}
            />
          )}
        </div>

        <p id={descId} className="project-modal__description">
          {project.fullDescription || project.description}
        </p>

        <div className="project-modal__actions" aria-label="Project links">
          {project.liveUrl && (
            <a
              className="project-modal__action project-modal__action--primary"
              href={project.liveUrl}
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                handleProjectLinkClick("live_site", project.liveUrl)
              }
            >
              Visit website
              <span className="sr-only"> (opens in a new tab)</span>
            </a>
          )}

          {project.githubUrl && (
            <a
              className="project-modal__action project-modal__action--secondary project-modal__action--icon"
              href={project.githubUrl}
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                handleProjectLinkClick("github", project.githubUrl)
              }
            >
              <img src={github} alt="" aria-hidden="true" width={18} height={18} />
              <span>View code</span>
              <span className="sr-only"> (opens in a new tab)</span>
            </a>
          )}

          {project.extraLinks?.map((link) => (
            <a
              key={link.href}
              className="project-modal__action project-modal__action--secondary"
              href={link.href}
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                handleProjectLinkClick(link.type || "external", link.href)
              }
            >
              {link.label}
              <span className="sr-only"> (opens in a new tab)</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectModal;
